import { useTranslation } from '@dreamstack/i18n'
import { Mail } from '@dreamstack/icons/src/icon-components/Mail'
import { Phone } from '@dreamstack/icons/src/icon-components/Phone'
import { motion } from 'framer-motion'
import type { FunctionComponent } from 'react'
import { cn } from '@dreamstack/util/src/cn'

export type HeaderProps = {
  displayOnTop?: boolean
  displayInMobileNav?: boolean
  isShown?: boolean
}

const containerBaseClass =
  'bg-accentroAquaVeryLight-full text-px-13 z-10 leading-px-18 md:py-px-4'
const containerTopClass =
  'hidden md:flex md:fixed md:top-0 md:w-full md:justify-center md:items-center md:space-x-px-16'
const containerMobileClass =
  'flex-col p-px-16 mt-px-12 -mb-px-16 md:hidden'

export const ContactHeaderForNavBar: FunctionComponent<
  React.PropsWithChildren<HeaderProps>
> = ({ displayInMobileNav, displayOnTop, isShown }) => {
  const t = useTranslation()

  if (isShown) {
    return null
  }

  return (
    <motion.div
      className={cn(
        containerBaseClass,
        displayOnTop && containerTopClass,
        displayInMobileNav && containerMobileClass
      )}
    >
      <div className="flex flex-col md:flex-row">
        <span className="font-semibold mr-px-4">
          {t('accentro:contactHeaderQuestion')}
        </span>
        {t('accentro:contactHeaderHelp')}
      </div>
      <div className="flex mt-px-16 items-center md:mt-0">
        <Phone className="text-accentroAqua-full h-px-24 w-px-24 mr-px-4" />
        030 - 88 71 81 41
      </div>
      <div className="hidden items-center md:flex md:font-semibold md:space-x-px-16 md:mb-px-4">
        .
      </div>
      <a href="mailto:kundenmanagement@accentro.de">
        <div className="flex text-accentroAqua-full items-center">
          <Mail className="h-px-24 w-px-24 mr-px-4" />
          kundenmanagement​@accentro.de
        </div>
      </a>
    </motion.div>
  )
}
